import styled from '@emotion/styled';
import { mediaMobile } from 'components/core/theme/breakpoints';
import { FCWithChildren } from 'helpers/types/FCWithChildren';

const SneezeGuard = styled.div<{ noSneezeColor: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  ${props =>
    props.noSneezeColor
      ? 'background-color: rgba(255, 255, 255, 0.5);'
      : 'background-color: rgba(41, 41, 39, 0.8);'}
  backdrop-filter: blur(20px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
`;
const ModalWrapper = styled.div`
  position: fixed;
  border: none;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 1001;
  ${mediaMobile} {
    width: 95%;

    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    overflow: scroll;
    transform: unset;
    background: white;
    width: 100%;
  }
`;

export const ModalBody = styled.div`
  background-color: white;
  border-radius: 48px;
  border: 1px solid #f2f0ee;
  box-shadow: 0px 48px 48px 0px #2929270d;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 48px 48px 48px;

  ${mediaMobile} {
    padding: 16px 32px 32px 32px;
  }
`;

interface Props {
  onClose: () => void;
  noSneezeColor?: boolean;
}

export const Modal: FCWithChildren<Props> = ({
  onClose,
  children,
  noSneezeColor = false,
}) => (
  <>
    <SneezeGuard onClick={onClose} noSneezeColor={noSneezeColor}></SneezeGuard>
    <ModalWrapper>{children}</ModalWrapper>
  </>
);
